import { html } from "lit";
import { unsafeHTML } from "lit/directives/unsafe-html.js";
import { toSanitizedMarkdownHtml, toSanitizedStreamingMarkdownHtml } from "../markdown.ts";
import { detectTextDirection } from "../text-direction.ts";

export function renderRichMarkdown(markdown: string, opts?: { isStreaming?: boolean }) {
  return html`
    <div class="chat-rich-markdown chat-text" dir=${detectTextDirection(markdown)}>
      ${unsafeHTML(
        opts?.isStreaming
          ? toSanitizedStreamingMarkdownHtml(markdown, "chat-rich-streaming-caret")
          : toSanitizedMarkdownHtml(markdown),
      )}
    </div>
  `;
}
